module.exports = __webpack_public_path__ + "static/media/turkey-original.0fd62832.jpg";